if (!customElements.get('ugc-strip')) {
  class UgcStrip extends HTMLElement {
    connectedCallback() {
      this.tiles = Array.from(this.querySelectorAll('.ugc-strip__tile'));

      this.tiles.forEach((tile) => {
        const video = tile.querySelector('video');
        if (!video) return;

        tile.addEventListener('click', () => {
          if (video.paused) {
            this.loadVideo(video);
            this.pauseAll(tile);
            video.muted = false;
            video.play();
            tile.classList.add('is-playing');
          } else {
            video.pause();
            tile.classList.remove('is-playing');
          }
        });

        video.addEventListener('ended', () => tile.classList.remove('is-playing'));
      });
    }

    // Only called from the click handler now - the previous
    // IntersectionObserver-triggered version (firing as a tile scrolled
    // near view, not on tap) downloaded several megabytes per video
    // instead of the expected few KB, since several of these clips
    // aren't "fast start" encoded. See the matching fix in
    // ugc-video-carousel.js for the full story - this component had the
    // same bug and was missed the first time around.
    loadVideo(video) {
      if (!video.dataset.lazySrc) return;
      video.src = video.dataset.lazySrc;
      video.preload = 'metadata';
      delete video.dataset.lazySrc;
    }

    pauseAll(except) {
      this.tiles.forEach((tile) => {
        if (tile === except) return;
        const video = tile.querySelector('video');
        if (video && !video.paused) video.pause();
        tile.classList.remove('is-playing');
      });
    }
  }

  customElements.define('ugc-strip', UgcStrip);
}
